export default __webpack_public_path__ + "static/media/nbqsa.6436f2c6.png";